export const INIT_TUTORIAL = 'TUTORIAL/INIT_TUTORIAL'
export const END_TUTORIAL = 'TUTORIAL/END_TUTORIAL'

export const SET_USER_MAP = 'TUTORIAL/SET_USER_MAP'
export const SET_VISITOR_MAP = 'TUTORIAL/MAP_SET_VISITOR_MAP'
export const MODIFY_VISITOR_BUILDING = 'TUTORIAL/MODIFY_VISITOR_BUILDING'

export const GO_TO = 'TUTORIAL/GO_TO'
export const OPEN_MINE = 'TUTORIAL/OPEN_MINE'
export const CLICK_TILE = 'TUTORIAL/CLICK_TILE'

export const SHOW_MESSAGE = 'TUTORIAL/SHOW_MESSAGE'
export const HIDE_MESSAGE = 'TUTORIAL/HIDE_MESSAGE'

export const CHANGE_MINING_SCREEN = 'TUTORIAL/CHANGE_MINING_SCREEN'
export const CHANGE_MINING_SCREEN_SUCCESS = 'TUTORIAL/CHANGE_MINING_SCREEN_SUCCESS'

export const ANSWER_QUESTION = 'TUTORIAL/ANSWER_QUESTION'
export const CREATE_QUESTION = 'TUTORIAL/CREATE_QUESTION'
export const VOTE_QUESTION = 'TUTORIAL/VOTE_QUESTION'

export const SET_VOTE_QUESTION = 'TUTORIAL/SET_VOTE_QUESTION'
export const SET_CURRENT_STORE = 'TUTORIAL/SET_CURRENT_STORE'
export const SAVE_VISITOR_MAP = 'TUTORIAL/SAVE_VISITOR_MAP'

export const SET_FEED_BACK = 'TUTORIAL/SET_FEED_BACK'
export const ADD_COINS = 'TUTORIAL/ADD_COINS'
export const CLEAR_FEED_BACK = 'TUTORIAL/CLEAR_FEED_BACK'
export const END_FLOW = 'TUTORIAL/END_FLOW'
export const SET_COUNTERS_DATA = 'TUTORIAL/SET_COUNTERS_DATA'
export const SET_USER_DATA = 'TUTORIAL/SET_USER_DATA'
export const SET_CURRENT_QUESTION = 'TUTORIAL/SET_CURRENT_QUESTION'
export const CLICK_ACADEMY_SWITCH = 'TUTORIAL/CLICK_ACADEMY_SWITCH'
export const MODIFY_DISPUTES_AMOUNT = 'TUTORIAL/MODIFY_DISPUTES_AMOUNT'

export const CREATE_BATTLE = 'TUTORIAL/CREATE_BATTLE'

export const CREATE_BUILDING = 'TUTORIAL/CREATE_BUILDING'
export const CREATE_BUILDING_SUCCESS = 'TUTORIAL/CREATE_BUILDING_SUCCESS'
export const CREATE_BUILDING_ERROR = 'TUTORIAL/CREATE_BUILDING_ERROR'
export const UPGRADE_BUILDING = 'TUTORIAL/UPGRADE_BUILDING'
export const UPGRADE_BUILDING_SUCCESS = 'TUTORIAL/UPGRADE_BUILDING_SUCCESS'
export const UPGRADE_BUILDING_ERROR = 'TUTORIAL/UPGRADE_BUILDING_ERROR'
export const REMOVE_BUILDING = 'TUTORIAL/REMOVE_BUILDING'
export const REMOVE_BUILDING_SUCCESS = 'TUTORIAL/REMOVE_BUILDING_SUCCESS'
export const REMOVE_BUILDING_ERROR = 'TUTORIAL/REMOVE_BUILDING_ERROR'
export const GET_PROFILE_BATTLES = 'TUTORIAL/GET_PROFILE_BATTLES'

export const REMOVE_POPUP = 'TUTORIAL/REMOVE_POPUP'
export const ADD_POPUP = 'TUTORIAL/ADD_POPUP'
export const ADD_SCREEN = 'TUTORIAL/ADD_SCREEN'
export const REMOVE_SCREEN = 'TUTORIAL/REMOVE_SCREEN'

export const END_TURN = 'TUTORIAL/END_TURN'
export const REMOVE_QUESTION = 'TUTORIAL/REMOVE_QUESTION'
export const SET_MINING_UI = 'TUTORIAL/SET_MINING_UI'
export const SET_MAP_UI = 'TUTORIAL/SET_MAP_UI'
export const SET_PHASE1_HIDE_UI = 'TUTORIAL/SET_PHASE1_HIDE_UI'
export const NEXT_PHASE = 'TUTORIAL/NEXT_PHASE'
export const NEXT_TURN = 'TUTORIAL/NEXT_TURN'

export const SET_DEBATES_INFO = 'TUTORIAL/SET_DEBATES_INFO'

export const MODIFY_PRIZE = 'TUTORIAL/MODIFY_PRIZE'

export const SHOW_INDICATORS = 'TUTORIAL/SHOW_INDICATORS'
export const TRIGGER_SELECT_TAB = 'TUTORIAL/TRIGGER_SELECT_TAB'

export const MODIFY_INDICATORS = 'TUTORIAL/MODIFY_INDICATORS'
export const MODIFY_BUILDINGS = 'TUTORIAL/MODIFY_BUILDINGS'
export const NOOP = 'TUTORIAL/NOOP'

export const SET_CONFIDENTIAL_NUMBER = 'TUTORIAL/SET_CONFIDENTIAL_NUMBER'

export const SET_BATTLE = 'TUTORIAL/SET_BATTLE'
export const START_CURRENT_BATTLE = 'TUTORIAL/START_CURRENT_BATTLE'
export const END_CURRENT_BATTLE = 'TUTORIAL/END_CURRENT_BATTLE'
export const ANSWER_BATTLE_QUESTION = 'TUTORIAL/ANSWER_BATTLE_QUESTION'
export const SET_INDIVIDUAL_BATTLE = 'TUTORIAL/SET_INDIVIDUAL_BATTLE'
export const LOAD_VISITOR_MAP = 'TUTORIAL/MAP_LOAD_VISITOR_MAP'
export const BACK_TO_RANKING = 'TUTORIAL/MAP_BACK_TO_RANKING'

export const LOAD_I18N_MESSAGES = 'TUTORIAL/LOAD_I18N_MESSAGES'

export const INIT_TUTORIAL_URL = 'TUTORIAL/INIT_TUTORIAL_URL'

export const SET_USER_INFO_FAKE = 'TUTORIAL/SET_USER_INFO_FAKE'
export const SET_ACTIVITY = 'TUTORIAL/SET_ACTIVITY'
export const SET_CURRENT_USER = 'TUTORIAL/SET_CURRENT_USER'

export const GIVE_UP_BATTLE = 'TUTORIAL/GIVE_UP_BATTLE'

export const noop = () => ({
  type: NOOP,
})

export const giveUpBattle = () => ({
  type: GIVE_UP_BATTLE,
})

export const SET_AVAILABLE_BUILDINGS = 'TUTORIAL_SET_AVAILABLE_BUILDINGS'

export const initTutorial = () => ({
  type: INIT_TUTORIAL,
})

export const endTutorial = () => ({
  type: END_TUTORIAL,
})

export const setUserMap = (data) => ({
  type: SET_USER_MAP,
  data,
})

export const setVisitorMap = (map) => {
  return { type: SET_VISITOR_MAP, data: map }
}

export const goTo = (data) => ({
  type: GO_TO,
  data,
})

export const openMine = () => ({
  type: OPEN_MINE,
})

export const clickTile = () => ({
  type: CLICK_TILE,
})

export const modifyBuildings = (buildings) => ({
  type: MODIFY_BUILDINGS,
  data: buildings,
})

export const modifyPrize = (prize) => ({
  type: MODIFY_PRIZE,
  data: prize,
})
export const modifyDisputesAmount = (amount) => ({
  type: MODIFY_DISPUTES_AMOUNT,
  data: amount,
})

export const createQuestion = () => ({
  type: CREATE_QUESTION,
})

export const createBattle = (params) => ({
  type: CREATE_BATTLE,
  data: params,
})

export const getProfileBattles = () => {
  return { type: GET_PROFILE_BATTLES }
}
export const voteQuestion = () => ({
  type: VOTE_QUESTION,
})

export const showMessage = (data) => ({
  type: SHOW_MESSAGE,
  data,
})

export const hideMessage = () => ({
  type: HIDE_MESSAGE,
})

export const changeMiningScreen = (screenId) => ({
  type: CHANGE_MINING_SCREEN,
  data: screenId,
})

export const changeMiningScreenSuccess = (screenId) => ({
  type: CHANGE_MINING_SCREEN_SUCCESS,
  data: screenId,
})

export const answerQuestion = (data) => ({
  type: ANSWER_QUESTION,
  data,
})

export const setVoteQuestion = (data) => ({
  type: SET_VOTE_QUESTION,
  data,
})

export const setFeedBack = (data) => ({
  type: SET_FEED_BACK,
  data,
})

export const addCoins = (data) => ({
  type: ADD_COINS,
  data,
})

export const modifyIndicators = (data) => ({
  type: MODIFY_INDICATORS,
  data,
})

export const modifyVisitorBuilding = (data) => ({
  type: MODIFY_VISITOR_BUILDING,
  data,
})
export const setCurrentStore = (data) => ({
  type: SET_CURRENT_STORE,
  data,
})

export const clearFeedBack = () => ({
  type: CLEAR_FEED_BACK,
})

export const endFlow = () => ({
  type: END_FLOW,
})

export const setCountersData = (data) => ({
  type: SET_COUNTERS_DATA,
  data,
})

export const setUserData = (data) => ({
  type: SET_USER_DATA,
  data,
})

export const setCurrentQuestion = (data) => ({
  type: SET_CURRENT_QUESTION,
  data,
})

export const clickAcademySwitch = () => ({
  type: CLICK_ACADEMY_SWITCH,
})

export const createBuilding = (data) => ({
  type: CREATE_BUILDING,
  data,
})

export const createBuildingSuccess = (data) => ({
  type: CREATE_BUILDING_SUCCESS,
  data,
})

export const createBuildingError = (data) => ({
  type: CREATE_BUILDING_ERROR,
  data,
})

export const upgradeBuilding = (data) => ({
  type: UPGRADE_BUILDING,
  data,
})

export const upgradeBuildingSuccess = (data) => ({
  type: UPGRADE_BUILDING_SUCCESS,
  data,
})

export const upgradeBuildingError = (data) => ({
  type: UPGRADE_BUILDING_ERROR,
  data,
})

export const removePopup = (data) => ({
  type: REMOVE_POPUP,
  data,
})

export const addPopup = (data) => ({
  type: ADD_POPUP,
  data,
})

export const addScreen = (data) => ({
  type: ADD_SCREEN,
  data,
})

export const removeScreen = (data) => ({
  type: REMOVE_SCREEN,
  data,
})

export const endTurn = () => ({
  type: END_TURN,
})

export const removeQuestion = () => ({
  type: REMOVE_QUESTION,
})
export const setMapUI = (data) => ({
  type: SET_MAP_UI,
  data,
})
export const setMiningUI = (data) => ({
  type: SET_MINING_UI,
  data,
})
export const setPhase1HideUI = (data) => ({
  type: SET_PHASE1_HIDE_UI,
  data,
})
export const setDebatesInfo = (data) => ({
  type: SET_DEBATES_INFO,
  data,
})

export const nextPhase = () => ({
  type: NEXT_PHASE,
})

export const nextTurn = () => ({
  type: NEXT_TURN,
})

export const showIndicators = () => ({
  type: SHOW_INDICATORS,
})

export const triggerSelectTab = (data) => ({
  type: TRIGGER_SELECT_TAB,
  data,
})

export const setConfidentialNumber = () => ({
  type: SET_CONFIDENTIAL_NUMBER,
})

export const setAvailableBuildings = (data) => ({
  type: SET_AVAILABLE_BUILDINGS,
  data,
})

export const setBattle = (battle) => {
  return { type: SET_BATTLE, data: battle }
}

export const saveVisitorMap = () => {
  return { type: SAVE_VISITOR_MAP }
}
export const startCurrentBattle = () => {
  return { type: START_CURRENT_BATTLE }
}

export const endCurrentBattle = () => {
  return { type: END_CURRENT_BATTLE }
}

export const answerBattleQuestion = (question) => {
  return { type: ANSWER_BATTLE_QUESTION, data: question }
}
export const setIndividualBattle = (battle) => {
  return { type: SET_INDIVIDUAL_BATTLE, data: battle }
}

export const loadVisitorMap = (uid) => {
  return { type: LOAD_VISITOR_MAP, data: uid }
}

export const backToRanking = (bool) => {
  return { type: BACK_TO_RANKING, data: bool }
}

export const loadI18NMessages = () => ({
  type: LOAD_I18N_MESSAGES,
})

export const initTutorialUrl = () => ({
  type: INIT_TUTORIAL_URL,
})

export const setUserInfoFake = (userInfo) => ({
  type: SET_USER_INFO_FAKE,
  data: userInfo,
})

export const setActivity = (activity) => ({
  type: SET_ACTIVITY,
  data: activity,
})

export const setCurrentUser = (user) => ({
  type: SET_CURRENT_USER,
  data: user,
})
